export const getCompany = () => {
    return {
        company: {
            _id: '5d77f9e1070856f3828945c5',
            name: 'Mocky',
            branding: {
                logo: {
                    url: 'https://cdn.atomicfi.com/mocky-logo.svg'
                }
            }
        }
    };
};
//# sourceMappingURL=get-company.js.map